module.exports = __webpack_public_path__ + "static/media/silkycloud-4.05422525.png";